import { jsx as o, jsxs as c } from "react/jsx-runtime";
import { withManagedProps as m } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as d } from "@made-people/react-prop-guard";
import { tableBlueprint as b } from "./index-blueprint.es.js";
import s from "clsx";
import "@made-people/blueprint";
const h = t.object({
  variants: t.custom().optional(),
  firstColumnAsHeader: t.boolean().optional(),
  content: t.object({
    thead: t.array(t.object({ value: t.string() })).optional(),
    tbody: t.array(
      t.object({
        body: t.array(t.object({ value: t.string() }))
      })
    ).optional()
  }).optional()
}), y = (a) => {
  const e = b.styles(a.variants);
  return a.content ? /* @__PURE__ */ o("div", { className: e.base, children: /* @__PURE__ */ c("table", { className: e.table, children: [
    a.content.thead && /* @__PURE__ */ o("thead", { className: e.headingWrapper, children: /* @__PURE__ */ o("tr", { children: a.content.thead.map((n, r) => /* @__PURE__ */ o(
      "td",
      {
        className: s(
          e.heading,
          a.firstColumnAsHeader && r === 0 && "sticky left-0 z-10 bg-gray-100"
        ),
        children: n.value
      },
      r
    )) }) }),
    a.content.tbody && /* @__PURE__ */ o("tbody", { className: e.body, children: a.content.tbody.map((n, r) => /* @__PURE__ */ o("tr", { className: e.row, children: n.body.map(
      (i, l) => a.firstColumnAsHeader && l === 0 ? /* @__PURE__ */ o(
        "th",
        {
          scope: "row",
          className: s(
            e.heading,
            "sticky left-0 z-10",
            r % 2 === 0 ? "bg-white" : "bg-gray-100"
          ),
          children: i.value
        },
        l
      ) : /* @__PURE__ */ o("td", { className: e.item, children: i.value }, l)
    ) }, r)) })
  ] }) }) : null;
}, w = m("Table", d(h, y));
export {
  w as Table,
  h as tableSchema
};
//# sourceMappingURL=index.es.js.map
